const defaultSiteUrl = 'http://localhost:8081'

/** Production marketing site — used for rel=canonical on every page, all environments. */
export const CANONICAL_SITE_URL = 'https://www.podiummarkets.ai'

export const siteConfig = {
  name: 'Podium Markets',
  shortName: 'Podium',
  defaultLocale: 'en',
  canonicalSiteUrl: CANONICAL_SITE_URL,
  get siteUrl() {
    const fromEnv = import.meta.env.VITE_SITE_BASE_URL?.replace(/\/$/, '')
    return fromEnv || defaultSiteUrl
  },
  ogImagePath: '/og.svg',
  /** Square app icon (matches pod-marketing-app public assets). */
  appIconPath: '/android-chrome-512x512.png',
  appleTouchIconPath: '/apple-touch-icon.png',
  twitterHandle: '@PodiumMarketsAI',
} as const

export function absoluteUrl(path: string): string {
  const base = siteConfig.siteUrl
  if (path.startsWith('http')) return path
  return `${base}${path.startsWith('/') ? path : `/${path}`}`
}

export function canonicalUrl(path: string): string {
  if (path.startsWith('http')) return path
  const normalized = path.startsWith('/') ? path : `/${path}`
  return `${CANONICAL_SITE_URL}${normalized === '/' ? '/' : normalized}`
}
